<template>
    <input
        v-bind="$attrs"
        :type="type"
        :value="displayValue"
        @input="onInput"
    />
</template>

<script>
import {defaultTokens, maskValue} from './masker'

export default {
    name: 'TheMask',
    inheritAttrs: false,
    props: {
        modelValue: [String, Number],
        mask: {
            type: [String, Array],
            required: true,
        },
        masked: {
            // По умолчанию отдаём в модель значение без форматирования
            type: Boolean,
            default: false,
        },
        tokens: {
            type: Object,
            default: () => defaultTokens,
        },
        type: {
            type: String,
            default: 'text',
        },
    },
    emits: ['update:modelValue', 'input'],
    computed: {
        displayValue() {
            return maskValue(this.modelValue, this.mask, true, this.tokens)
        },
    },
    methods: {
        onInput(event) {
            const rawValue = event.target.value
            const maskedValue = maskValue(rawValue, this.mask, true, this.tokens)
            const emittedValue = this.masked
                ? maskedValue
                : maskValue(rawValue, this.mask, false, this.tokens)

            this.$emit('update:modelValue', emittedValue)
            this.$emit('input', emittedValue)

            if (maskedValue !== event.target.value) {
                event.target.value = maskedValue
            }
        },
    },
}
</script>
